import { ExportCategoriesI } from "./ExportCategories";

export const ExportGraphCategories: ExportCategoriesI[] = [
  {
    value: "graph_binder",
    label: "export.graph.binder",
    selected: true,
    disabled: true,
  },
  {
    value: "graph_brn",
    label: "export.graph.brn",
    selected: true,
    disabled: true,
  },
  {
    value: "graph_mixing_penetration_rate",
    label: "export.graph.mixing-penetration_rate",
    selected: true,
    disabled: true,
  },
  {
    value: "graph_hydraulic_pressure_rotary",
    label: "export.graph.hydraulic_pressure_rotary",
    selected: false,
    disabled: false,
  },
  {
    value: "graph_hydraulic_pressure_winch",
    label: "export.graph.hydraulic_pressure_winch",
    selected: false,
    disabled: false,
  },
];
